module.exports = __webpack_public_path__ + "static/media/pinkbg.9bc93ec4.svg";